import axios from 'axios';

const verifyOtp = (mobileNumber, otp) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/api/user/verify-otp`, { mobileNumber, otp })
    .then(res => res)
    .catch(err => err);
};

export default verifyOtp;
